import { buildTrimmedParams } from './yardiInviteFormatters'
import { LIST_FILTER_QUERY_KEYS } from '../constants'
import type { YardiInviteListFilterForm } from '../types'

/** Extract only the list filter fields for trimming. */
function listFormFieldsForTrim(form: YardiInviteListFilterForm): Record<string, unknown> {
  return {
    q: form.q,
    org_id: form.org_id,
    company_id: form.company_id,
    property_id: form.property_id,
  }
}

/** Builds GET /api/yardi_invite params: base → session snapshot (first load only) → trimmed form. */
export function buildYardiInviteListParams(
  page: number,
  form: YardiInviteListFilterForm,
  sortBy: 'asc' | 'desc',
  orderBy: string,
  perPage: number,
  sessionMerge: { apply: boolean; snapshot: Record<string, unknown> | null },
): Record<string, string | number | boolean | string[] | undefined> {
  const nextParams: Record<string, string | number | boolean | string[] | undefined> = {
    perPage,
    page,
    sortBy,
    orderBy,
  }
  if (sessionMerge.apply && sessionMerge.snapshot) {
    Object.assign(nextParams, { ...sessionMerge.snapshot } as Record<
      string,
      string | number | boolean | string[] | undefined
    >)
  }
  // Strip merged session keys so cleared form fields aren't re-added from the snapshot.
  for (const key of LIST_FILTER_QUERY_KEYS) {
    delete (nextParams as Record<string, unknown>)[key]
  }
  Object.assign(nextParams, buildTrimmedParams(listFormFieldsForTrim(form)))
  return nextParams
}
